module.exports = __webpack_public_path__ + "static/img/banner-bg.10caee0a.png";